/**
  * Limit the number of times a function is called within defined timeout
  *
  * @param {form} form - Form to serialize
*/
$(document).ready(function() {
  updateTotalPrice();
  
    $('.productSelect').change(function() {
      updateTotalPrice();
    });
  
    function updateTotalPrice() {
      var total = 0;
  
      $('.productSelect').each(function() {
        var priceStr = $(this).find('option:selected').data('price');
        var price = parseFloat(priceStr.replace('$', '').replace(',', ''));
        total += price;
      });
  
      $('#addToCartBtn').text('ADD TO CART - $' + total.toFixed(2));
    }
    
  $('#addToCartBtn').click(function() {
      var selectedProductIds = [];
      $('.productSelect').each(function() {
        var selectedIds = $(this).val();
        if (selectedIds && selectedIds.length > 0) {
          selectedProductIds = selectedProductIds.concat(selectedIds);
        }
      });
  
      if (selectedProductIds.length === 0) {
        console.error('No products selected');
        return;
      }
  
      // Prepare the array of items to add to the cart
      var items = selectedProductIds.map(function(productId) {
        return { quantity: 1, id: productId };
      });
  
      // Add all items to the cart in a single request
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: items },
        dataType: 'json',
        success: function() {
          console.log('All products added to cart');
          // Redirect to the cart page
        var cart = new theme.CartDrawer
            cart.init()
            cart.open();
        //  window.location.href = '/cart';
        },
        error: function(xhr, status, error) {
          console.error('Error adding products to cart');
        }
      });
    });
  });
  
  
  
  
  
  
  const serializeForm = form => {
      const obj = {};
      const formData = new FormData(form);
    
      for (const key of formData.keys()) {
        const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
        if (regex.test(key)) {
          obj.properties = obj.properties || {};
          obj.properties[regex.exec(key)[2]] = formData.get(key);
        } else {
          obj[key] = formData.get(key);
        }
      }
    
      return JSON.stringify(obj);
    };
  
  /**
   * Product Form Components
   *
   */
  class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      //   this.cartElement = document.querySelector('ajax-cart');
      }
    
      /**
       * Product Form Submit event
       *
       * @param {evt} Event instance
       */
      onSubmitHandler(evt) {
        evt.preventDefault();
        const items = [];
        const qtyInput = this.querySelector('[data-qty-input]');
    
        items.push(JSON.parse(serializeForm(this.form)));
  
        let addOnVariantID = document.querySelector('.addOnVariantID').value;
  
        let addOnJSON = {
          id: addOnVariantID,
          quantity: qtyInput.value
        }
        items.push(addOnJSON);
  
        const formData = JSON.stringify({
          items
        });
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: formData
        })
        .then(response => {
          window.location.href = "/cart";
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    }
    customElements.define('product-form', ProductForm);